<template>
  <div class="container">
    <div class="row">
      <table class="table table-basic mt-4 mb-4">
        <thead>
          <tr>
            <th class="w-220">輸入人員</th>
            <td>{{ UserInfo.name }}</td>
          </tr>
          <tr>
            <th class="w-220">
              <span class="text-red">*</span>簡覆表編號
            </th>
            <td>
              <input
                type="text"
                :id="`div-name-form_no-${colKey}`"
                :data-vv-name="`div-name-form_no-${colKey}`"
                placeholder="請輸入簡覆表編號"
                v-validate="'required'"
                data-vv-as="簡覆表編號"
                class="form-control w-50"
                v-model="form.form_no"
                alt="ch"
                :class="{ 'is-invalid': errors.has(`div-name-form_no-${colKey}`) }"
                @input="checkFormNo"
                @blur="checkFormNo"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">
              <span class="text-red">*</span>同仁ID
            </th>
            <td>
              <input
                type="text"
                maxlength="10"
                :id="`div-name-fmlyid-${colKey}`"
                :data-vv-name="`div-name-fmlyid-${colKey}`"
                placeholder="請輸入同仁ID"
                v-validate="'required|checkIDLength'"
                data-vv-as="同仁ID"
                class="form-control w-50"
                v-model="form.fmlyid"
                :class="{ 'is-invalid': errors.has(`div-name-fmlyid-${colKey}`) }"
                @input="checkKeyword('fmlyid')"
                @blur="checkKeyword('fmlyid')"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">
              <span class="text-red">*</span>服務人員ID
            </th>
            <td>
              <input
                type="text"
                maxlength="10"
                :id="`div-name-agid-${colKey}`"
                :data-vv-name="`div-name-agid-${colKey}`"
                placeholder="請輸入服務人員ID"
                v-validate="'required|checkIDLength'"
                data-vv-as="服務人員ID"
                class="form-control w-50"
                v-model="form.agid"
                :class="{ 'is-invalid': errors.has(`div-name-agid-${colKey}`) }"
                @input="checkKeyword('agid')"
                @blur="checkKeyword('agid')"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">開放日期</th>
            <td>{{ moment().getROCDate('YYYY/MM/DD') }}</td>
          </tr>
          <tr>
            <th class="w-220">備註</th>
            <td>
              <input
                type="text"
                placeholder="請輸入備註"
                class="form-control"
                v-model="form.memo"
                @input="checkMemo"
                @blur="checkMemo"
              />
            </td>
          </tr>
        </thead>
      </table>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doReset(true)">重設</a>
          <a class="btn btn-primary" @click="doSubmit">確定</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '@/mixins/common';
//component
import mxMask from '@/desktop/components/mxMask';
//service
import { checkAGExist, addAGFamily } from '@/service';
import { Validator } from 'vee-validate';

export default {
  name: 'BullentinContent',
  mixins: [commonMixin],
  components: { mxMask },
  props: {},
  computed: {
    ...mapGetters(['UserInfo']),
  },
  watch: {},
  mounted() {
    this.initValidator();
  },
  data() {
    return {
      mxMaskOpen: false,
      mxMaskContent: '資料儲存中，請稍候...',
      form: {
        agid: '', //業務員ID
        form_no: '', //簡覆表編號
        fmlyid: '', //同仁ID
        memo: '',//備註
        create_id: this.$store.state.userInfo.id, //服務人員ID
      },
      idChk: false, //ID是否存在
      colKey: '1', //串欄位key用
    };
  },
  methods: {
    ...mapActions(['setPageLock']),
    //檢核ID
    checkKeyword(id) {
      if (this.form[id]) {
        this.form[id] = this.form[id].toUpperCase();
        let val = this.form[id].substring(0, 1);
        if (val === '*') {
          this.form[id] = val + this.form[id].substring(1, this.form[id].length).replace(/[^a-zA-Z0-9]+/g, '');
        } else {
          this.form[id] = this.form[id].replace(/[^a-zA-Z0-9]+/g, '');
        }
      }
      if (this.stringBytes(this.form[id], false, 10) > 10) {
        this.form[id] = this.form[id].substring(0, this.stringBytes(this.form[id], true, 10));
      }
    },
    //檢查備註長度(varchar100)
    checkMemo() {
      if (this.stringBytes(this.form.memo, false, 100) > 100) {
        this.form.memo = this.form.memo.substring(0, this.stringBytes(this.form.memo, true, 100));
      }
    },
    //檢查簡覆表編號長度(varchar50)
    checkFormNo() {
      if (this.stringBytes(this.form.form_no, false, 50) > 50) {
        this.form.form_no = this.form.form_no.substring(0, this.stringBytes(this.form.form_no, true, 50));
      }
    },
    //重置空值顯示框
    setNotEmpty() {
      this.webLinkEmpty = false;
    },
    //重設
    doReset(showMsg) {
      this.webLinkEmpty = false;
      this.form = {
        agid: '',
        form_no: '',
        fmlyid: '',
        memo: '',
        create_id: this.$store.state.userInfo.id,
      };
      if (showMsg) {
        this.$toast.info({ title: '畫面重設成功' });
      }
    },
    checkExist() {
      checkAGExist(this.UserInfo.id, this.form).then(result => {
        if (result.header && result.header.status == '200') {
          addAGFamily(this.UserInfo.id, this.form).then(result => {
            if (result.header && result.header.status == '200') {
              this.$toast.info({ title: '眷屬資料新增成功' });
              this.form = {
                agid: '',
                agnm: '',
                form_no: '',
                fmlyid: '',
                fmlynm: '',
                memo: '',
                create_id: this.$store.state.userInfo.id,
              };
              this.mxMaskOpen = false;
            } else {
              this.$toast.info({ title: result.header.message });
              this.mxMaskOpen = false;
            }
          });
        } else if (result.header && result.header.status == '400') {
          this.$toast.info({ title: '此ID非在職人員' });
          this.mxMaskOpen = false;
        } else {
          this.$toast.info({ title: result.header.message });
          this.mxMaskOpen = false;
        }
      });
    },
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        } else {
          this.mxMaskOpen = true;
          this.checkExist();
        }
        this.$validator.reset();
      });
    },
    //檔案上傳
    changeInput() {
      let vm = this;
      if (!vm.$refs.myFiles.files || vm.$refs.myFiles.files.length == 0) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.file = vm.$refs.myFiles.files[0];
      let fileType = vm.file.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (fileType.indexOf('pdf') !== -1 || fileType.indexOf('png') !== -1 || fileType.indexOf('jpeg') !== -1) {
        //檢查檔案大小
        if (vm.$refs.myFiles.files[0].size > 5000000) {
          vm.setToastMsg('檔案大小不得超過5MB');
          vm.file = {};
          vm.form.filename = '';
        } else {
          vm.file = vm.$refs.myFiles.files[0];
          vm.form.filename = vm.file.name;
        }
      } else {
        vm.setToastMsg('檔案格式不支援');
        vm.file = {};
        vm.form.filename = '';
      }
    },
    initValidator() {
      // 初始自訂義檢核
      Validator.extend('checkIDLength', {
        getMessage: field => {
          return `${field}長度不可少於10碼`;
        },
        validate: value => {
          return value.trim().length == 10;
        }
      });
    },
  },
};
</script>
<style>
input[type='file'] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.span-color-black {
  color: black;
}
.text-area-pattern {
  padding: 9px 10px;
  border: 1px solid #c2c4c7;
  border-radius: 4px;
  font-size: 16px !important;
  line-height: 1 !important;
  resize: none;
}
.text-area-height {
  height: 250px;
}
</style>